import React from "react";

import styles from "./ToggleInput.module.scss";

type Props = {
  label: string;
  name: string;
  id: string;
  value: boolean;
  onChange: () => void;
  description?: string;
};

const ToggleInput: React.FC<Props> = ({
  label,
  name,
  id,
  value,
  onChange,
  description,
}) => {
  return (
    <div className={styles["c-toggle"]}>
      <div className={styles["c-toggle__text-area"]}>
        <div className={styles["c-toggle__title"]}>{label}</div>
        {description ? (
          <div className={styles["c-toggle__desc"]}>{description}</div>
        ) : null}
      </div>
      <input
        type="checkbox"
        id={id}
        name={name}
        onChange={onChange}
        checked={value}
      />
      <label className={styles["c-toggle__btn"]} htmlFor={id}></label>
    </div>
  );
};

export default ToggleInput;
